import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { FeatureFlagKey } from 'constants/featureFlags'
import { makeIsFeatureEnabledSelector } from 'redux/selectors/featureFlags'

const useFeatureFlag = (flagKey: FeatureFlagKey): boolean => {
  const selector = useMemo(() => makeIsFeatureEnabledSelector(flagKey), [flagKey])
  return useSelector(selector)
}

export default useFeatureFlag
